export const isUrl = str => /^(http|https|ftp):\/\//.test(str);

export default isUrl;
